import { ComponentType } from 'react';

import JobsZeroResults from '@/components/jobs-zero-results';
import Link, { LinkVariant } from '@/components/link';
import SimpleJobListItem from '@/components/simple-job-list-item';

import JobBlocks from '@/features/job-blocks';
import jobCategoryJobBlocksFromJobListProps from '@/features/job-category-page/mappers/job-category-job-blocks.mapper';
import { jobSearchQueryFromJobCategoryPage } from '@/features/job-category-page/mappers/job-category-job-search.mapper';
import { jobCategoryPageJobsZeroResultsFromJobListProps } from '@/features/job-category-page/mappers/job-category-zero-jobs-list.mapper';
import { GetJobCategoryPageJobsRelatedJobsLevel } from '@/features/job-category-page/services/public-jobs.service';
import { JobCategoryPage } from '@/features/job-category-page/types';
import { Job } from '@/services/public-jobs.service';
import { routes } from '@/utils/route-utils';

type JobListType = 'simple' | 'detailed';

const componentByType: Record<JobListType, ComponentType<Job>> = {
  simple: SimpleJobListItem,
  detailed: SimpleJobListItem,
};

export type JobListProps = {
  id: string;
  page: JobCategoryPage;
  jobs: Job[];
  relatedJobs?: Job[];
  relatedJobsLevel?: GetJobCategoryPageJobsRelatedJobsLevel;
  maxLength?: number;
};

export default function JobList(props: JobListProps) {
  const { page, jobs, relatedJobs = [], maxLength = 10 } = props;

  const type: JobListType = 'simple';
  const Component = componentByType[type];
  const jobSearchRedirectPath = routes.jobSearch(
    jobSearchQueryFromJobCategoryPage(page)
  );

  return (
    <div className='flex w-full flex-col'>
      {jobs.length > 0 && (
        <>
          <div className='flex w-full flex-col gap-4 overflow-hidden bg-white'>
            {jobs.map((job) => (
              <Component key={job.id} {...job} />
            ))}
          </div>

          {jobs.length >= maxLength && (
            <div className='mt-16 flex w-full justify-center'>
              <Link
                href={jobSearchRedirectPath}
                variant={LinkVariant.PRIMARY_BUTTON}
              >
                Load More
              </Link>
            </div>
          )}
        </>
      )}

      {jobs.length > 0 && relatedJobs?.length > 0 && (
        <div className='mt-8'>
          <div className='bg-primary-extra-light'>
            <JobBlocks {...jobCategoryJobBlocksFromJobListProps(props)} />
          </div>
        </div>
      )}

      {jobs.length === 0 && (
        <JobsZeroResults
          {...jobCategoryPageJobsZeroResultsFromJobListProps(props)}
        />
      )}
    </div>
  );
}
